import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-load-detail-time-line-pending.svg",
  "use": "icon-load-detail-time-line-pending.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-load-detail-time-line-pending.svg\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#005EE9\" width=\"16\" height=\"16\" rx=\"8\" /><path d=\"m5.47 11.712 1.06 1.061L11.303 8 6.53 3.227l-1.06 1.06L9.182 8z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol